module.exports = __webpack_public_path__ + "img/sf-icon.9a167f1.png";